var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-grid__item\tm-aside-left  m-aside-left--skin-dark ",attrs:{"id":"m_aside_left"}},[_c('div',{staticClass:"m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark ",staticStyle:{"position":"relative"},attrs:{"id":"m_ver_menu","m-menu-vertical":'1',"m-menu-scrollable":'1',"m-menu-dropdown-timeout":'500'}})])])}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dashboard/admin/common/menus/LeftMenu.vue?vue&type=template&id=50d4daea&
// module id = null
// module chunks = 